import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import { DevFlagsFetchResponse, TellentDevFlagsMap } from '@core/tellent-types';

import { buildFlagsMap } from './utils';

@Injectable({ providedIn: 'root' })
export class TellentDevFlagsHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);

  public fetch(): Observable<TellentDevFlagsMap> {
    return this.httpApi
      .get('/features')
      .pipe(map((resp: DevFlagsFetchResponse) => buildFlagsMap(resp.data)));
  }
}
